import styled, { css } from 'styled-components';

const generalFlexStyles = css`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Container = styled.section`
    ${generalFlexStyles};
    width: 100%;
    flex-direction: column;
    padding: 50px 20px 112px;
    background-color: #fbfbfb;
    @media (max-width: 767px) {
        padding: 50px 15px 40px;
    }
`;

export const Inner = styled.div`
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const IconList = styled.ul`
    ${generalFlexStyles};
    padding: 0;
    margin: 0 0 32px;
    max-width: 100%;
    flex-wrap: wrap;
    gap: 8px;
`;

export const IconItem = styled.li`
    margin-right: 12px;
    &:last-child {
        margin-right: 0;
    }
`;

export const Description = styled.article`
    ${generalFlexStyles};
    flex-direction: column;
    margin-bottom: 32px;
    max-width: 960px;
    width: 100%;
    @media (max-width: 767px) {
        margin-bottom: 24px;
        h1 {
            font-size: 30px !important;
        }
    }
    @media (max-width: 640px) {
        h1 {
            font-size: 26px !important;
            max-width: 400px;
        }
        p {
            max-width: 550px;
            margin: 0 auto;
        }
    }
    @media (max-width: 380px) {
        h1 {
            max-width: 340px;
        }
        p {
            max-width: 320px;
        }
    }
`;

export const RelatedLinks = styled.p`
    margin: 28px 0 0;
    font-size: 13px;
    color: #6b7280;
    text-align: center;
    a {
        color: #6b7280;
        text-decoration: underline;
        text-underline-offset: 2px;
        &:hover {
            color: #1268fb;
        }
    }
`;

export const TrustStrip = styled.p`
    font-size: 12px;
    color: #6b7280;
    text-align: center;
    margin: 10px 0 0;
    letter-spacing: 0.01em;
`;

export const Divider = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 560px;
    margin: 28px 0;
    color: #6b7280;
    font-size: 13px;
    gap: 12px;
    &::before,
    &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: #dee1e5;
    }
`;
